module.exports = __webpack_public_path__ + "static/media/PokemonPokedex_cover.f24a9350.png";